import { render } from "./ListComponent.vue?vue&type=template&id=5ce37d2e&scoped=true"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"

import "./ListComponent.vue?vue&type=style&index=0&id=5ce37d2e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce37d2e"]])

export default __exports__